import { AnimatePresence, motion } from "framer-motion";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { X, Phone, ArrowRight } from "lucide-react";
import { TOPICS } from "@/data/topics";

const SECTIONS = [
  { label: "FIND MY UNIT", id: "finder" },
  { label: "PRICES", id: "prices" },
  { label: "BOOK ONLINE", id: "book" },
  { label: "REVIEWS", id: "reviews" },
  { label: "ABOUT US", id: "about" },
  { label: "FAQ", id: "faq" },
];

export default function MenuDrawer({ open, onClose }) {
  const navigate = useNavigate();
  const location = useLocation();

  const goSection = (id) => {
    onClose();
    if (location.pathname === "/") {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(`/#${id}`);
    }
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[90] bg-tpeco-ink/60 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          data-testid="menu-overlay"
        >
          <motion.aside
            className="absolute right-0 top-0 h-full w-full max-w-sm bg-white border-l-4 border-tpeco-ink overflow-y-auto"
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ type: "spring", stiffness: 300, damping: 32 }}
            onClick={(e) => e.stopPropagation()}
            data-testid="menu-drawer"
          >
            <div className="flex items-center justify-between p-5 border-b-[3px] border-tpeco-ink">
              <span className="font-display uppercase text-2xl">MENU</span>
              <button onClick={onClose} aria-label="Close menu" className="w-10 h-10 rounded-full bg-tpeco-ink text-white flex items-center justify-center hover:bg-tpeco-pink transition-colors" data-testid="menu-close">
                <X className="w-5 h-5" strokeWidth={2.5} />
              </button>
            </div>
            <div className="p-5">
              <p className="text-xs font-extrabold uppercase tracking-widest text-neutral-400">ON THIS SITE</p>
              <ul className="mt-3 space-y-1">
                {SECTIONS.map((s) => (
                  <li key={s.id}>
                    <button onClick={() => goSection(s.id)} className="w-full flex items-center justify-between font-display uppercase text-2xl py-2 hover:text-tpeco-blue transition-colors" data-testid={`menu-section-${s.id}`}>
                      {s.label} <ArrowRight className="w-4 h-4 text-tpeco-pink" strokeWidth={2.5} />
                    </button>
                  </li>
                ))}
              </ul>
              <p className="mt-7 text-xs font-extrabold uppercase tracking-widest text-neutral-400">SOMETHING ELSE? WE CAN HELP!</p>
              <ul className="mt-3 space-y-1">
                {TOPICS.map((t) => (
                  <li key={t.slug}>
                    <Link to={`/${t.slug}`} onClick={onClose} className="w-full flex items-center justify-between font-display uppercase text-2xl py-2 hover:text-tpeco-blue transition-colors" data-testid={`menu-topic-${t.slug}`}>
                      {t.label} <ArrowRight className="w-4 h-4 text-tpeco-pink" strokeWidth={2.5} />
                    </Link>
                  </li>
                ))}
              </ul>
              <a href="tel:0475776555" className="btn-brutal w-full mt-7" data-testid="menu-call-button">
                <Phone className="w-5 h-5" strokeWidth={2.5} /> CALL 0475 776 555
              </a>
            </div>
          </motion.aside>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
